export default class Quote {
  constructor(departure, arrival, coupon = '') {
    const params = {
      currencyCode: 'EUR',
      dateTimeFrom: departure,
      dateTimeTo: arrival,
      labelAbbreviation: options.labelAbbreviation || 'QPA',
      locationAbbreviation: options.locationAbbreviation || 'AMS',
    };

    if (coupon) {
      params.couponCode = coupon;
    }

    return $.ajax({
      url: ajax_object.ajax_url,
      method: 'POST',
      dataType: 'json',
      data: {
        action: 'quick_parking/get_quote',
        parameters: params,
      },
    });
  }
}
